module.exports = __webpack_public_path__ + "static/media/chile-icon.7f330cfb.svg";